// extracted by mini-css-extract-plugin
module.exports = {"fluid-container":"_1PqkY","fluidContainer":"_1PqkY"};